import CompanyTable from "../../components/Company/CompanyTable"
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

function Company() {
  const { authState } = useSelector(
    (state) => state
  );
  const { loggedIn, userInfo } = authState;
  const navigate = useNavigate();

  useEffect(() => {
    if(loggedIn != true){
      navigate("/signin")
    }
  },[loggedIn, userInfo]);

  return (
    <div className="">
      <CompanyTable />
    </div>
  );
}

export default Company;
